import { Observable } from 'rxjs';

const supports = 'ResizeObserver' in window;
function watchResize(element) {
    return new Observable(observer => {
        if (!supports) {
            observer.complete();
            return () => { };
        }
        const resize = new ResizeObserver(([entry]) => {
            observer.next(entry);
        });
        resize.observe(element);
        return () => resize.disconnect();
    });
}

/**
 * Generated bundle index. Do not edit.
 */

export { watchResize };
